import { render, staticRenderFns } from "./App.vue?vue&type=template&id=53afa9df&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=53afa9df&prod&lang=less&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=53afa9df&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afa9df",
  null
  
)

export default component.exports